import { render } from "./NewsCard.vue?vue&type=template&id=2d5c80a5"
import script from "./NewsCard.vue?vue&type=script&lang=js"
export * from "./NewsCard.vue?vue&type=script&lang=js"

import "./NewsCard.vue?vue&type=style&index=0&id=2d5c80a5&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__